import HowToRegIcon from '@mui/icons-material/HowToReg';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { dashboardPrimaryActionButtonProps } from 'src/common/components/DashboardPageToolbar';

interface Props {
  activeEditionId: string | null | undefined;
  onClick: () => void;
  'data-testid'?: string;
  'data-tour'?: string;
}

const UserCheckinWizardOpenButton = ({
  activeEditionId,
  onClick,
  'data-testid': testId,
  'data-tour': tourId,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={
        activeEditionId
          ? t('userCheckinWizard.open')
          : t('userCheckinWizard.noActiveEdition')
      }
    >
      <span>
        <Button
          {...dashboardPrimaryActionButtonProps()}
          data-testid={testId}
          data-tour={tourId}
          disabled={!activeEditionId}
          onClick={onClick}
          startIcon={<HowToRegIcon />}
        >
          {t('userCheckinWizard.open')}
        </Button>
      </span>
    </Tooltip>
  );
};

export default UserCheckinWizardOpenButton;
